import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box } from '@mui/material';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';

const ConfirmationPopup = ({ open, onClose, onSubmit, data }) => {
  const userData = useSelector(state => state.user?.userData);

  const handleEditClick = () => {
    trackAnalyticsEvent('BENEFICIARY_CONFIRMATION_EDIT_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      account_number: data?.account_number || '',
      action: 'edit'
    });
    onClose();
  };

  const handleSubmitClick = () => {
    trackAnalyticsEvent('BENEFICIARY_CONFIRMATION_SUBMIT_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      account_number: data?.account_number || '',
      account_type: data?.account_type || '',
      action: 'submit'
    });
    onSubmit();
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{
            sx: { borderRadius: 3,}}
    }>
      <DialogTitle sx={{ fontWeight: 'bold', fontSize: '24px', fontWeight: 600, lineHeight: '40px', color: '#000' }}>
        Confirm Details
      </DialogTitle>

      <DialogContent>
        {[
          { label: 'Bank Account Number', value: data?.account_number },
          { label: 'IFSC', value: data?.ifsc_code },
          { label: 'Account Type', value: data?.account_type },
        ].map(({ label, value }) => (
          <Box key={label} sx={{ mb: 2 }}>
            <Typography variant='p3'  sx={{ color:'#666', fontWeight: 700 }}>{label}</Typography>
            <Typography variant="body2" fontWeight="500">{value}</Typography>
          </Box>
        ))}
        <Typography variant='body1' sx={{ color: '#008000' }}>
         Your a/c no. {data?.account_number} will be credited by ₹1
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 2 }}>
        <Button variant="outlined" color="primary" onClick={handleEditClick} sx={{ width: '50%', textTransform: 'none'}}>Edit</Button>
        <Button variant="contained" color="primary" onClick={handleSubmitClick} sx={{ width: '50%', textTransform: 'none'}}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
